import { render, staticRenderFns } from "./PriceCard.vue?vue&type=template&id=d8b9237a"
import script from "./PriceCard.vue?vue&type=script&lang=js"
export * from "./PriceCard.vue?vue&type=script&lang=js"
import style0 from "./scss/price-card.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8b9237a')) {
      api.createRecord('d8b9237a', component.options)
    } else {
      api.reload('d8b9237a', component.options)
    }
    module.hot.accept("./PriceCard.vue?vue&type=template&id=d8b9237a", function () {
      api.rerender('d8b9237a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/greenmotion-shared/Components/quotes/PriceCard.vue"
export default component.exports